export const computeRpcStatus = (execution, preFilled) => {
  // 2. запрошено выполнение
  const rpcRequested = () => {
    preFilled.icon.name = 'mdi-clock-outline';
    preFilled.icon.color = '';
  };
  // 3. вызов получен модулем (выполняется)
  const rpcInProgress = () => {
    preFilled.icon.name = 'mdi-reload';
    preFilled.icon.color = '';
  };
  // 4. выполнение закончено с ошибкой
  const doneWithError = () => {
    preFilled.icon.name = 'mdi-alert-circle-outline';
    preFilled.icon.color = '#D50000';
  };
  // 5. выполнение закончено без ошибки
  const doneWithoutError = () => {
    preFilled.icon.name = 'mdi-check-circle-outline';
    preFilled.icon.color = '';
  };

  if (execution.ack) {
    if (
      execution.done &&
      (execution.error === false ||
        execution.error === 'false' ||
        execution.error === null)
    ) {
      doneWithoutError();
      return;
    }

    if (
      execution.done &&
      (execution.error === true ||
        execution.error === 'true' ||
        execution.error !== null)
    ) {
      doneWithError();
      return;
    }

    if (!execution.done) {
      rpcInProgress();
    }
  } else {
    rpcRequested();
  }
};
